/**
 * KeywordRow — 키워드 목록의 한 줄. 누르면 그 키워드로 보고, 지우기 버튼으로 목록에서 뺀다.
 *
 * 기존 클래스(.mk-theme)를 그대로 소비한다 — 투자 테마 목록과 시각적으로 같아야 한다.
 * 내가 검색한 키워드와 서버가 준 투자 테마가 한 목록에 섞여 있고, 다른 것은 지우기
 * 버튼의 유무뿐이다(테마는 내 것이 아니라 지울 수 없다).
 *
 * 지우기 버튼은 별개의 button 이라 줄 전체를 button 으로 둘 수 없다 — button 안에
 * button 은 넣을 수 없다(HTML). 그래서 줄은 div, 이름 부분만 button 이다.
 */
export interface KeywordRowProps {
  keyword: string;
  /** 지금 보고 있는 키워드 */
  selected?: boolean;
  onPick: (keyword: string) => void;
  /** 지우기 — 주면 지우기 버튼이 붙는다. 내가 검색해 담은 키워드에만 준다 */
  onRemove?: (keyword: string) => void;
}

/**
 * 키워드 한 줄.
 *
 * 어디에 쓰였나: 시장 이슈 · 트렌드 탭 왼쪽 목록(내 키워드 · 투자 테마)
 */
export function KeywordRow({ keyword, selected, onPick, onRemove }: KeywordRowProps) {
  return (
    <div className="mk-kwrow">
      <button
        type="button"
        className={`mk-theme${selected ? " on" : ""}`}
        aria-pressed={selected}
        onClick={() => onPick(keyword)}
      >
        {keyword}
      </button>
      {onRemove && (
        <button
          type="button"
          className="mk-kw-del"
          title="목록에서 지우기"
          aria-label={`${keyword} 지우기`}
          onClick={() => onRemove(keyword)}
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={1.9}
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M6 6l12 12M18 6L6 18" />
          </svg>
        </button>
      )}
    </div>
  );
}
